import React from "react";
import { Link } from "react-router-dom";

interface ProductCardProps {
  image: string;
  title: string;
  id: number;
}

const ProductCard: React.FC<ProductCardProps> = ({ image, title, id }) => {
  return (
    <Link
      to={`/product/${id}`}
      className="flex flex-col items-center w-full cursor-pointer max-w-[297px] max-sm:h-[350px]"
    >
      <img
        src={image}
        alt={title}
        className="mb-5 rounded-3xl border-4 border-yellow-400 border-solid  w-[297px] max-sm:w-full object-contain h-[300px]"
      />
      <div className="text-xl font-bold text-center">{title}</div>
    </Link>
  );
};

export default ProductCard;
